import ModalController from "../../utils/ModalController";

export default class DownloadModal {
  constructor(el) {
    this.el = el;
    this.backdrop = el.querySelector(".c-download-modal__backdrop");
    this.closeBtn = el.querySelector(".c-download-modal__close");
    this.trigger = el.previousElementSibling;

    document.body.appendChild(this.el);

    this.controller = new ModalController({
      modal: this.el,
      backdrop: this.backdrop,
      closeBtn: this.closeBtn,
    });

    this.trigger?.addEventListener("click", (e) => {
      e.preventDefault();
      this.controller.open();
    });

    this.el.querySelectorAll('[aria-label="Copy key"]').forEach((btn) => {
      btn.addEventListener("click", () => this.copyKey(btn));
    });

    this.el.querySelectorAll('[aria-label="Remove"]').forEach((btn) => {
      btn.addEventListener("click", () => this.removeKey(btn));
    });

    this.list = el.querySelector(".c-download-modal__list");
    this.addBtn = el.querySelector('[aria-label="Add domain"]');
    this.inputTemplate = el.querySelector(".c-download-modal__input-template");
    this.maxDomains = parseInt(this.list?.dataset.maxDomains, 10) || Infinity;

    this.addBtn?.addEventListener("click", () => this.addDomainField());
    this.updateAddBtnState();
  }

  domainRowCount() {
    return this.list?.querySelectorAll(".c-download-modal__row:not(.c-download-modal__row--add)").length ?? 0;
  }

  hasPendingInputRow() {
    return (this.list?.querySelectorAll(".c-download-modal__row--input").length ?? 0) > 0;
  }

  updateAddBtnState() {
    if (!this.addBtn) return;

    const atLimit = this.domainRowCount() >= this.maxDomains || this.hasPendingInputRow();
    this.addBtn.disabled = atLimit;
    this.addBtn.classList.toggle("is-disabled", atLimit);
  }

  addDomainField() {
    if (this.domainRowCount() >= this.maxDomains || this.hasPendingInputRow()) return;

    const addRow = this.addBtn.closest(".c-download-modal__row--add");
    if (!addRow || !this.inputTemplate) return;

    const newRow = this.inputTemplate.content.firstElementChild.cloneNode(true);
    addRow.before(newRow);

    this.updateAddBtnState();
  }

  copyKey(btn) {
    const keyText = btn.closest(".c-download-modal__key")?.querySelector(".c-download-modal__key-text")?.textContent;
    if (!keyText) return;

    this.writeToClipboard(keyText).then(() => {
      btn.classList.add("is-copied");
      clearTimeout(btn._copiedTimeout);
      btn._copiedTimeout = setTimeout(() => btn.classList.remove("is-copied"), 1500);
    });
  }

  writeToClipboard(text) {
    if (navigator.clipboard?.writeText) {
      return navigator.clipboard.writeText(text);
    }

    // Fallback for non-secure contexts (e.g. http:// .local dev domains),
    // where the async Clipboard API isn't exposed.
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    textarea.remove();

    return Promise.resolve();
  }

  removeKey(btn) {
    const row = btn.closest(".c-download-modal__row");
    if (!row) return;

    row.classList.add("is-removing");
    row.addEventListener(
      "transitionend",
      () => {
        row.remove();
        this.updateAddBtnState();
      },
      { once: true }
    );
  }
}
